export enum PartyIdentificationType {
  ORGANISATION = 'ORGANISATION',
  PRIVATE = 'PRIVATE'
}

export enum IdentificationCodeType {
  LEI = 'LEI'
}

export const LEI_PATTERN = '^[A-Z0-9]{18,18}[0-9]{2,2}$';
